import {
  Component, Input, EventEmitter, OnInit, ElementRef, HostListener,
  ViewEncapsulation, AfterViewInit, ContentChildren, QueryList
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { TabModel } from './tab.model';
import { EmitterService } from './emitter.service';
import { TabComponent } from './tab.component';

@Component({
  selector: 'app-tabs',
  styleUrls: ['./tabs.component.scss'],
  templateUrl: './tabs.component.html',
  providers: [EmitterService],
  encapsulation: ViewEncapsulation.None
})

export class TabsComponent implements OnInit, AfterViewInit {

  @Input() tabs: TabModel[];
  @Input() ariaLabel: string;
  @ContentChildren( TabComponent ) tabsComponent: QueryList<TabComponent>;

  private subscription: Subscription;
  private curTab: any;
  private currentTabIndex: number;

  constructor(protected router: Router, private el: ElementRef, private emitter: EmitterService) {
    this.subscription = this.emitter.subscribe(tab => {
        this.tabAction(tab.id, false);
    });
    this.currentTabIndex = 0;
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].isActive) {
        this.tabAction(this.tabs[i].id, true);
      }
    }
  }

  onResize(event) {
    if (this.curTab == null) {
      this.curTab = this.tabs[0].id;
    }
    this.tabAction(this.curTab, true);
  }

  tabAction(tab, onpageLoad) {

    this.curTab = tab;
    let w = window.innerWidth;
    for (let option of this.tabs) {
      if (w > 1024) {
        if (option.id === tab) {
          option.isActive = true;
          setTimeout(() => { // added timeout to wait for dom load.
            let container = document.getElementById(option.id);
            this.htmlHeight(container);
          }, 0);
        } else {
          option.isActive = false;
        }
      } else {
        if (option.id === tab) {
          if (onpageLoad === true) {
            // option.isActive = option.isActive;
            option.isActive = true;
          } else {
            option.isActive = !option.isActive;
          }
        } else {
          option.isActive = false;
        }
      }
    }

    this.bringFocusToSelectedTab();

  }

  // brings focus to the tab selected using arrow keys.
  bringFocusToSelectedTab(){
    ( <any>this.tabsComponent.toArray()[ this.currentTabIndex ] ).el.nativeElement.children[0].children[0].focus();
  }

  /*
     code: "ArrowRight", key: "ArrowRight",keyCode: 39
     code: "ArrowLeft",key: "ArrowLeft",keyCode: 37
     Handle left and right arrow key to navigate between tabs
  */
  handleKeyDown( event ){
      
    if( event.keyCode === 39 ){ // ArrowRight
      if( this.currentTabIndex !== this.tabs.length - 1 ){
        this.currentTabIndex++;
      } else{
        this.currentTabIndex = 0;
      }
      this.bringFocusToSelectedTab();
    }else if( event.keyCode === 37 ){  // ArrowLeft
      if( this.currentTabIndex !== 0 ){
        this.currentTabIndex--;
      }else{
        this.currentTabIndex = this.tabs.length - 1;
      }
      this.bringFocusToSelectedTab();
    }
    
  }

  // on tab click or enter, the currentTabIndex has to be updated with the selected tab index.
  handleTabsClick( event ){

    if( event.target.tagName === "A" ){
      this.tabs.forEach( ( tab, index ) => {
        if( tab.id === event.target.textContent.trim() )
          this.currentTabIndex = index;
      })
    }

  }


  htmlHeight(container) {
    let divHeight = container.offsetHeight;
    let totalHeight = divHeight + 70;
    document.getElementById('tabContainer').style.height = totalHeight + 'px';
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
